import { useState, ReactNode } from 'react';
import './style.scss';

export const enum CheckLabelLinkTextColor {
  Link = 'linkText',
  Black = 'blackText',
}

export const enum CheckLabelTextSize{
  Large = 'large'
}

type CheckLabelProps = {
  checked: boolean;
  onChange: () => void;
  before?: string | ReactNode;
  after?: string | ReactNode;
  link?: string;
  href?: string;
  linkClicked?: boolean;
  onClick?: () => void;
  textSize? : CheckLabelTextSize;
  linkClickedRequired?: boolean;
  linkTextColor?: CheckLabelLinkTextColor;
  errorText? : string;
};

export const CheckLabel = (props: CheckLabelProps) => {
  const { checked, onChange, before, after, link, href, linkClicked, onClick, textSize, linkClickedRequired, linkTextColor , errorText} =
    props;
  const [isLinkClickedRequiredError, setIsLinkClickedRequiredError] = useState<boolean>(false);

  return (
    <div className="checkLabelWrapper">
      <div className="checkLabel">
        <input
          className="checkLabel_box"
          type="checkbox"
          checked={checked}
          onChange={() => {
            if (linkClickedRequired) {
              if (linkClicked) {
                onChange();
                setIsLinkClickedRequiredError(false);
              } else {
                setIsLinkClickedRequiredError(true);
              }
            } else {
              onChange();
            }
          }}
        />
        <div className={`checkLabel_labels ${textSize ?? ''}`}>
          <span>
            {before}
            <a
              href={href}
              className={`checkLabel_labels_link ${linkTextColor ? linkTextColor : CheckLabelLinkTextColor.Link}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                onClick?.();
              }}
            >
              {link}
            </a>
            {after}
          </span>
        </div>
      </div>
      {isLinkClickedRequiredError && (
        <div className="checkLabelWrapper_error">{errorText ?? 'リンクから内容を確認後にチェックしてください'}</div>
      )}
    </div>
  );
};
